import { render, staticRenderFns } from "./OverDueReport.vue?vue&type=template&id=5ad4464a"
import script from "./OverDueReport.vue?vue&type=script&lang=js"
export * from "./OverDueReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports